import React from 'react';
import { MDBBtnFixedItem, MDBCard, MDBCardTitle, MDBCardText, MDBFormInline, MDBBadge, MDBContainer, MDBListGroup, MDBListGroupItem, MDBRow, MDBCol, MDBBtn, MDBIcon } from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Header from './ComponentFragments/Header';
import SalesCard from './ComponentFragments/SalesCard';


export default class Sales extends React.Component {

    constructor(props) {
        super(props);
        this.props.loaderOn();
        this.state = {
            salesData: [],
            filteredData: []
        }
        this.searchList = this.searchList.bind(this);
        this.props.loaderOff();
    }

    searchList(phrase) {
        let arr = [];
        let TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        arr = this.state.salesData.filter((dem) => (dem.demName.toUpperCase().includes(phrase.toUpperCase())) || (dem.unitName.toUpperCase().includes(phrase.toUpperCase())))
        this.setState({ filteredData: arr });
    }

    async componentWillMount() {
        var dl = new DataLayer();
        await dl.Get('/common/getsales', 200).then((response) => {
            this.setState({
                salesData: response.data,
                filteredData: response.data
            });
            this.props.loaderOff();
        })
    }


    render() {
        let headerText = "Who\'s Selling";
        return (
            <div>
                <Header headerText={headerText}
                    placeholderText="Search Demonstrators"
                    searchList={this.searchList}
                />
                <MDBRow>
                    {
                        this.state.filteredData.map((dem) => {
                            var ttt = "";
                            return (
                                <MDBCol xl="3" lg="3" md="4" sm="12" className="mb-r" >
                                    <SalesCard
                                        demCode={dem.demCode}
                                        sales={dem.sales}
                                        unitName={dem.unitName}
                                        telephoneCell={dem.telephoneCell}
                                        demName={dem.demName}
                                        prevSegmentSales={dem.prevSegmentSales}
                                    />
                                </MDBCol>


                            );
                        })
                    }
                </MDBRow>


            </div>
        );
    }
}